import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c74b6bba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=c74b6bba&prod&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=c74b6bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74b6bba",
  null
  
)

export default component.exports